import { Button, Typography, Dialog, DialogContent, DialogTitle, DialogActions, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

interface OvertimeRule {
    overtime_rule_id: number;
    name: string;
}

interface Zone {
    zone_id: number;
    name: string;
}

interface ScheduleDesviationRule {
    schedule_desviation_rule_id: number;
    name: string;
}

interface CombinationRuleRow {
    id: number;
    name: string;
    description?: string;
    overtime_rules?: OvertimeRule[];
    zones?: Zone[];
    schedule_desviation_rules?: ScheduleDesviationRule[];
}

interface DeleteCombinationProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    select: CombinationRuleRow;
    reloading: () => void;
}

const DeleteCombination = ({ open, setOpen, select, reloading }: DeleteCombinationProps) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='sm'
            aria-labelledby="delete-combination-dialog-title"
        >
            <DialogTitle id="delete-combination-dialog-title">{t('settings.combinations.dialog.titles.delete')}</DialogTitle>
            <IconButton
                id='delete-combination-dialog-title'
                onClick={() => setOpen(false)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Typography variant="body1">{t('settings.combinations.dialog.alerts.delete.message')}</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color='error' onClick={() => setOpen(false)}>{t('settings.combinations.dialog.buttons.cancel')}</Button>
                <Button variant='contained' color='primary' onClick={() => console.log('select:', select.id)}>{t('settings.combinations.dialog.buttons.delete')}</Button>
            </DialogActions>
        </Dialog>
    )

}

export { DeleteCombination };
